/*
 * Espacio Unno · las interacciones de la home, en JavaScript de navegador.
 * Sustituye a Motion, Embla y Base UI del sitio original sin cambiar el gesto:
 * revelados al entrar en pantalla, carruseles con snap, acordeón, mega menú,
 * menú móvil y los ojitos que siguen al cursor.
 */
(function () {
  "use strict";

  var quieto = window.matchMedia("(prefers-reduced-motion: reduce)");

  /* ------------------------------------------------------------ revelados */
  function revelados() {
    /* Lo que vive dentro de una cinta lo revela la propia cinta al montar: un
       observador ahi no sirve (los clones nacen sin que nadie los mire) y en
       el editor de temas, que re-inyecta la seccion, dejaba una tarjeta a
       opacidad 0 en medio de la fila. */
    var piezas = Array.prototype.filter.call(
      document.querySelectorAll(".eu-revela, .eu-mascara"),
      function (p) {
        return !p.closest("[data-eu-pista]");
      },
    );
    if (!piezas.length) return;

    if (!("IntersectionObserver" in window)) {
      piezas.forEach(function (p) {
        p.classList.add("eu-visible");
      });
      return;
    }

    /* Red de seguridad: si a los dos segundos algo sigue sin revelarse y esta
       dentro de la ventana, se revela igual. Un observador que no dispara —el
       iframe del editor, una pestaña en segundo plano— no puede dejar huecos. */
    window.setTimeout(function () {
      piezas.forEach(function (p) {
        if (p.classList.contains("eu-visible")) return;
        var r = p.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight + 200) p.classList.add("eu-visible");
      });
    }, 2000);

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add("eu-visible");
          obs.unobserve(e.target);
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -48px 0px" },
    );

    piezas.forEach(function (p) {
      obs.observe(p);
    });
  }

  /* ----------------------------------------------------------- carruseles
   *
   * Una cinta infinita de verdad: la tira se mueve con transform, no con el
   * scroll del navegador. Con scroll nativo el salto del bucle peleaba con la
   * animacion suave y con el iman del scroll-snap, y se veia el retroceso.
   * Moviendo la tira a mano, el salto es un cambio de coordenada entre copias
   * identicas: invisible por definicion.
   *
   * La tira se clona a los lados, asi que a izquierda y derecha siempre hay
   * material. Los clones no existen para el teclado ni para el lector.
   */
  var ESPERA_AUTOPLAY = 4000;
  var DURACION_PASO = 620;

  function suave(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function carrusel(raiz) {
    /* arrancar() corre otra vez con cada shopify:section:load, y los
       relacionados llegan tarde: sin este sello el carrusel ya montado se
       volveria a envolver y la tira quedaria dentro de si misma. */
    if (raiz.getAttribute("data-eu-carrusel-listo")) return;
    var pista = raiz.querySelector("[data-eu-pista]");
    if (!pista) return;
    raiz.setAttribute("data-eu-carrusel-listo", "1");

    var originales = Array.prototype.slice.call(pista.children);
    var total = originales.length;
    if (!total) return;

    var anterior = raiz.querySelector("[data-eu-anterior]");
    var siguiente = raiz.querySelector("[data-eu-siguiente]");
    var puntos = Array.prototype.slice.call(raiz.querySelectorAll("[data-eu-punto]"));
    var autoplay = parseInt(raiz.getAttribute("data-eu-autoplay") || "0", 10);

    /* La pista pasa a ser la ventana que recorta; dentro va la tira, que se
       queda con el layout (flex, gap, reticula) y es la que se mueve. */
    var tira = pista.querySelector("[data-eu-tira]");
    if (!tira) {
      var eraGrid = /\beu-pista--grid\b/.test(pista.className);
      tira = document.createElement("div");
      tira.setAttribute("data-eu-tira", "true");
      // El sangrado lateral se queda en la ventana —es lo que hace que la
      // tarjeta siguiente asome hasta el filo—; el layout se va a la tira.
      var deVentana = [];
      var deTira = [];
      pista.className.split(/\s+/).forEach(function (c) {
        if (!c || /^eu-pista(--grid)?$/.test(c)) return;
        if (/^(-?[a-z]+:)?-?(mx|px|ms|me|ps|pe)-/.test(c)) deVentana.push(c);
        else deTira.push(c);
      });
      tira.className = deTira.join(" ");
      pista.className = ["eu-pista", eraGrid ? "eu-pista--grid" : ""].concat(deVentana).filter(Boolean).join(" ");
      originales.forEach(function (s) {
        tira.appendChild(s);
      });
      pista.appendChild(tira);
    }

    /* Todo lo que hay en la tira se da por revelado al montar. La entrada
       escalonada no tiene sentido dentro de una cinta, y esperar a que la
       seccion este a la vista era justo lo que fallaba en el editor. */
    Array.prototype.forEach.call(tira.children, function (c) {
      c.classList.add("eu-visible");
    });
    tira.querySelectorAll(".eu-revela, .eu-mascara").forEach(function (e) {
      e.classList.add("eu-visible");
    });

    var clonado = false;
    var copias = 1;
    var bloque = 0;
    var x = 0;
    var destino = 0;
    var animacion = null;
    var reloj = null;
    var reposo = null;
    var enMano = false;
    var visible = true;
    var arrastre = null;

    /**
     * Hay cinta siempre que la seccion este en modo carrusel (en reticula, no).
     * Ojo: no vale condicionarlo a que la tira desborde. En pantallas anchas
     * caben las seis piezas de los videos, no se clonaba nada... y las flechas
     * seguian empujando la tira, dejando el hueco en blanco de la derecha.
     */
    function enCinta() {
      return getComputedStyle(pista).overflowX === "hidden" && total > 1;
    }

    function marcarClon(nodo) {
      nodo.setAttribute("data-eu-clon", "true");
      nodo.setAttribute("aria-hidden", "true");
      nodo.querySelectorAll("[id]").forEach(function (e) {
        e.removeAttribute("id");
      });
      nodo.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach(function (e) {
        e.setAttribute("tabindex", "-1");
      });
      // Las copias nunca corren prisa: que el navegador las traiga cuando toque
      // y reutilice lo que ya descargó para la pieza original.
      nodo.querySelectorAll("img").forEach(function (i) {
        i.setAttribute("loading", "lazy");
        i.setAttribute("decoding", "async");
        i.removeAttribute("fetchpriority");
      });
      // El tema marca los botones de carrito que ya engancho y luego los salta:
      // sin quitar la marca, el boton del clon se quedaria muerto.
      nodo.querySelectorAll("[data-ajax-initialized]").forEach(function (e) {
        e.removeAttribute("data-ajax-initialized");
      });
      return nodo;
    }

    /**
     * La entrada escalonada no sirve dentro de una cinta: una tarjeta que vive
     * fuera del recorte no llega a "entrar en pantalla" nunca, y se quedaria a
     * opacidad 0 dejando un hueco en blanco. Los clones, ademas, nacen sin que
     * nadie los observe. Asi que en cuanto la seccion esta a la vista, todas
     * las tarjetas de la tira se dan por reveladas.
     */
    function revelarTodo() {
      Array.prototype.forEach.call(tira.children, function (c) {
        c.classList.add("eu-visible");
      });
      tira.querySelectorAll(".eu-revela, .eu-mascara").forEach(function (e) {
        e.classList.add("eu-visible");
      });
    }

    function medir() {
      var hijos = tira.children;
      bloque = clonado && hijos[total] ? hijos[total].offsetLeft - hijos[0].offsetLeft : 0;
    }

    function clonar() {
      if (clonado || total < 2) return;
      // Con una sola copia a cada lado no basta cuando la tira original es mas
      // corta que la ventana: al desplazarse un bloque, el borde derecho se
      // queda sin material y aparece el hueco. Se clona lo que haga falta.
      // Una copia a cada lado basta cuando la tira ya es más ancha que la
      // ventana; solo se añaden más si la tira es corta. Cada copia de más son
      // las mismas imágenes pedidas otra vez.
      copias = Math.max(1, Math.ceil(pista.clientWidth / Math.max(1, tira.scrollWidth)));
      var delante = document.createDocumentFragment();
      var detras = document.createDocumentFragment();
      for (var c = 0; c < copias; c++) {
        originales.forEach(function (s) {
          delante.appendChild(marcarClon(s.cloneNode(true)));
          detras.appendChild(marcarClon(s.cloneNode(true)));
        });
      }
      tira.appendChild(detras);
      tira.insertBefore(delante, tira.firstChild);
      clonado = true;
      revelarTodo();
      if (typeof window.initCartAjaxHandlers === "function") window.initCartAjaxHandlers();
      medir();
      x = inicio();
      destino = x;
      aplicar();
    }

    /** Donde empieza la copia "de verdad", con las copias de cortesia detras. */
    function inicio() {
      return bloque * copias;
    }

    function quitarClones() {
      if (!clonado) return;
      Array.prototype.slice.call(tira.querySelectorAll("[data-eu-clon]")).forEach(function (n) {
        n.remove();
      });
      clonado = false;
      copias = 1;
      bloque = 0;
      x = 0;
      destino = 0;
      aplicar();
    }

    /** El bucle: la coordenada vive siempre dentro de la copia del medio. */
    function normalizar() {
      if (!clonado || !bloque) return;
      var base = inicio();
      while (x >= base + bloque) {
        x -= bloque;
        destino -= bloque;
      }
      while (x < base) {
        x += bloque;
        destino += bloque;
      }
    }

    function aplicar() {
      tira.style.transform = clonado || x ? "translate3d(" + -x + "px,0,0)" : "";
    }

    function paso() {
      var hijos = tira.children;
      if (hijos.length < 2) return pista.clientWidth;
      return Math.abs(hijos[1].offsetLeft - hijos[0].offsetLeft) || pista.clientWidth;
    }

    function indice() {
      var p = paso();
      if (!p) return 0;
      var n = Math.round((x - (clonado ? inicio() : 0)) / p);
      return ((n % total) + total) % total;
    }

    function pintar() {
      // En bucle no hay extremos: las flechas nunca se apagan.
      if (anterior) anterior.disabled = false;
      if (siguiente) siguiente.disabled = false;
      var i = indice();
      puntos.forEach(function (b, n) {
        b.setAttribute("aria-current", String(n === Math.min(i, puntos.length - 1)));
      });
    }

    function irA(nuevo, animado) {
      if (animacion) cancelAnimationFrame(animacion);
      destino = nuevo;
      if (!animado || quieto.matches) {
        x = destino;
        normalizar();
        aplicar();
        pintar();
        return;
      }
      var desde = x;
      var salto = destino - desde;
      var t0 = null;
      animacion = requestAnimationFrame(function cuadro(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / DURACION_PASO);
        x = desde + salto * suave(k);
        aplicar();
        pintar();
        if (k < 1) {
          animacion = requestAnimationFrame(cuadro);
        } else {
          animacion = null;
          normalizar();
          aplicar();
        }
      });
    }

    function mover(delta) {
      irA(destino + paso() * delta, true);
    }

    /** Cualquier gesto pausa el autoplay; vuelve solo tras unos segundos. */
    function actividad() {
      enMano = true;
      window.clearTimeout(reposo);
      reposo = window.setTimeout(function () {
        enMano = false;
      }, ESPERA_AUTOPLAY);
    }

    if (anterior) {
      anterior.addEventListener("click", function () {
        actividad();
        mover(-1);
      });
    }
    if (siguiente) {
      siguiente.addEventListener("click", function () {
        actividad();
        mover(1);
      });
    }
    puntos.forEach(function (b, n) {
      b.addEventListener("click", function () {
        actividad();
        irA((clonado ? inicio() : 0) + paso() * n, true);
      });
    });

    /* Arrastre con el dedo o el raton. El navegador ya no desplaza la pista,
       asi que el gesto lo lleva esto; el eje vertical se le deja a la pagina,
       que si no el carrusel se comeria el scroll. */
    pista.addEventListener(
      "pointerdown",
      function (e) {
        if (e.button != null && e.button !== 0) return;
        /* El visor 3D se gira con el mismo gesto: ahi dentro la cinta no manda. */
        if (e.target && e.target.closest && e.target.closest("[data-sin-arrastre]")) return;
        arrastre = { x0: e.clientX, y0: e.clientY, inicio: x, eje: null, id: e.pointerId };
        actividad();
        if (animacion) {
          cancelAnimationFrame(animacion);
          animacion = null;
          destino = x;
        }
      },
      { passive: true },
    );

    window.addEventListener(
      "pointermove",
      function (e) {
        if (!arrastre || e.pointerId !== arrastre.id) return;
        var dx = e.clientX - arrastre.x0;
        var dy = e.clientY - arrastre.y0;
        if (!arrastre.eje) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          arrastre.eje = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        }
        if (arrastre.eje !== "x") return;
        x = arrastre.inicio - dx;
        destino = x;
        normalizar();
        aplicar();
        pintar();
      },
      { passive: true },
    );

    ["pointerup", "pointercancel"].forEach(function (ev) {
      window.addEventListener(
        ev,
        function (e) {
          if (!arrastre || e.pointerId !== arrastre.id) return;
          var movido = arrastre.eje === "x";
          arrastre = null;
          actividad();
          if (!movido) return;
          var p = paso();
          irA(Math.round(x / p) * p, true);
        },
        { passive: true },
      );
    });

    raiz.addEventListener("mouseenter", function () {
      enMano = true;
      window.clearTimeout(reposo);
    });
    raiz.addEventListener("mouseleave", actividad);
    raiz.addEventListener("focusin", function () {
      enMano = true;
      window.clearTimeout(reposo);
    });
    raiz.addEventListener("focusout", function (e) {
      if (!raiz.contains(e.relatedTarget)) actividad();
    });

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        if (visible) window.setTimeout(revelarTodo, 500);
      }).observe(raiz);
    }

    function montar() {
      if (enCinta()) {
        if (!clonado) clonar();
        else {
          medir();
          normalizar();
          aplicar();
        }
      } else {
        quitarClones();
      }
      pintar();
    }

    montar();
    window.addEventListener("resize", debounce(montar, 200));

    if (autoplay > 0) {
      reloj = window.setInterval(function () {
        if (enMano || quieto.matches || document.hidden || !visible || !clonado) return;
        mover(1);
      }, autoplay);
      window.addEventListener("pagehide", function () {
        window.clearInterval(reloj);
      });
    }
  }

  function debounce(fn, ms) {
    var t = null;
    return function () {
      window.clearTimeout(t);
      t = window.setTimeout(fn, ms);
    };
  }

  /* ------------------------------------------------------------- acordeón */
  /* Altura animada con estilos en linea: la hoja no necesita clases nuevas y
     el gesto es el mismo que Base UI pone en el sitio. Con quietud pedida,
     solo se muestra u oculta. */
  var quietoAcordeon = window.matchMedia("(prefers-reduced-motion: reduce)");
  function despliega(panel, abrir) {
    if (quietoAcordeon.matches) {
      panel.hidden = !abrir;
      return;
    }
    panel.style.transition = "none";
    if (abrir) panel.hidden = false;
    var alto = panel.scrollHeight;
    panel.style.overflow = "hidden";
    panel.style.height = (abrir ? 0 : alto) + "px";
    panel.getBoundingClientRect();
    panel.style.transition = "height 0.35s cubic-bezier(0.16, 1, 0.3, 1)";
    panel.style.height = (abrir ? alto : 0) + "px";
    var tanda = (panel.euTanda || 0) + 1;
    panel.euTanda = tanda;
    function fin() {
      if (panel.euTanda !== tanda) return;
      panel.euTanda = 0;
      panel.style.transition = "";
      panel.style.height = "";
      panel.style.overflow = "";
      if (!abrir) panel.hidden = true;
    }
    panel.addEventListener("transitionend", fin, { once: true });
    window.setTimeout(fin, 450);
  }

  function acordeon(raiz) {
    /* arrancar() vuelve a correr con cada shopify:section:load —el editor, y
       los relacionados al llegar—. Sin este sello, cada pasada enganchaba otro
       manejador y dos toggles por clic dejaban el acordeón como estaba. */
    if (raiz.getAttribute("data-eu-acordeon-listo")) return;
    raiz.setAttribute("data-eu-acordeon-listo", "1");
    var botones = raiz.querySelectorAll("[data-eu-pregunta]");
    botones.forEach(function (b) {
      b.addEventListener("click", function () {
        var panel = document.getElementById(b.getAttribute("aria-controls"));
        var abierto = b.getAttribute("aria-expanded") === "true";
        b.setAttribute("aria-expanded", String(!abierto));
        if (panel) despliega(panel, !abierto);
        /* El giro del + vive en `group-data-panel-open:rotate-45` y el borde
           abierto en `data-open:`, que vienen del sitio (alli los pone Base
           UI). Aqui hay que poner los atributos a mano. */
        if (abierto) {
          b.removeAttribute("data-panel-open");
          b.parentElement.removeAttribute("data-open");
        } else {
          b.setAttribute("data-panel-open", "");
          b.parentElement.setAttribute("data-open", "");
        }
      });
    });
  }

  /* ------------------------------------------------------------ mega menú */
  /* Sella un elemento para no engancharlo dos veces. Antes se sellaba la
     PÁGINA, y el editor de temas recarga la cabecera entera cada vez que el
     cliente toca un ajuste: los nodos nuevos se quedaban muertos y había que
     recargar para que el menú volviera a abrir. */
  function sellar(el) {
    if (!el || el.dataset.euListo) return false;
    el.dataset.euListo = "1";
    return true;
  }

  function megaMenu() {
    var boton = document.querySelector("[data-eu-mega-boton]");
    var panel = document.querySelector("[data-eu-mega-panel]");
    if (!boton || !panel || !sellar(boton)) return;
    var reloj = null;

    function abrir() {
      window.clearTimeout(reloj);
      boton.setAttribute("aria-expanded", "true");
      panel.hidden = false;
    }
    function cerrar() {
      boton.setAttribute("aria-expanded", "false");
      panel.hidden = true;
    }
    function cerrarConGracia() {
      window.clearTimeout(reloj);
      reloj = window.setTimeout(cerrar, 180);
    }

    /* Solo el ratón abre al pasar por encima. En una pantalla táctil de 1024
       o más (iPad apaisado, portátil táctil) el toque disparaba primero el
       mouseenter y enseguida el click, que lo volvía a cerrar. */
    function soloRaton(fn) {
      return function (e) {
        if (e.pointerType && e.pointerType !== "mouse") return;
        fn();
      };
    }
    boton.addEventListener("pointerenter", soloRaton(abrir));
    boton.addEventListener("pointerleave", soloRaton(cerrarConGracia));
    panel.addEventListener("pointerenter", soloRaton(abrir));
    panel.addEventListener("pointerleave", soloRaton(cerrarConGracia));
    boton.addEventListener("click", function (e) {
      e.preventDefault();
      if (boton.getAttribute("aria-expanded") === "true") cerrar();
      else abrir();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && boton.getAttribute("aria-expanded") === "true") {
        cerrar();
        boton.focus();
      }
    });
    document.addEventListener("click", function (e) {
      if (!panel.contains(e.target) && !boton.contains(e.target)) cerrar();
    });
  }

  /* ----------------------------------------------------------- menú móvil */
  function menuMovil() {
    var abrir = document.querySelector("[data-eu-menu-abrir]");
    var cajon = document.querySelector("[data-eu-menu]");
    if (!abrir || !cajon || !sellar(abrir)) return;
    var cerrar = cajon.querySelectorAll("[data-eu-menu-cerrar]");

    function ver(v) {
      cajon.hidden = !v;
      abrir.setAttribute("aria-expanded", String(v));
      document.documentElement.style.overflow = v ? "hidden" : "";
      if (v) {
        var primero = cajon.querySelector("a, button");
        if (primero) primero.focus();
      } else {
        abrir.focus();
      }
    }

    abrir.addEventListener("click", function () {
      ver(cajon.hidden);
    });
    cerrar.forEach(function (b) {
      b.addEventListener("click", function () {
        ver(false);
      });
    });
    cajon.addEventListener("click", function (e) {
      if (e.target.hasAttribute("data-eu-menu-fondo")) ver(false);
      if (e.target.closest("a")) ver(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !cajon.hidden) ver(false);
    });
  }

  /* ---------------------------------------------------- cabecera pegajosa */
  var cabeceraEnganchada = false;
  function cabecera() {
    var el = document.querySelector("[data-eu-cabecera]");
    if (!el) return;
    /* La cabecera se busca DENTRO de pintar(): cuando el editor la recarga, el
       nodo es otro, y una referencia capturada apuntaría al que ya no existe. */
    function pintar() {
      var hoy = document.querySelector("[data-eu-cabecera]");
      if (hoy) hoy.setAttribute("data-pegada", String(window.scrollY > 24));
    }
    if (!cabeceraEnganchada) {
      cabeceraEnganchada = true;
      window.addEventListener("scroll", pintar, { passive: true });
    }
    pintar();
  }

  /* -------------------------------------------------- ojitos que te miran */
  var ojitosEnganchados = false;
  function ojitos() {
    if (quieto.matches || ojitosEnganchados) return;
    if (!document.querySelector("[data-eu-ojito]")) return;
    ojitosEnganchados = true;
    window.addEventListener(
      "pointermove",
      function (e) {
        /* Se consultan en cada movimiento, no una vez: así los ojitos de una
           sección recién recargada también miran. */
        document.querySelectorAll("[data-eu-ojito]").forEach(function (o) {
          var c = o.getBoundingClientRect();
          var dx = e.clientX - (c.left + c.width / 2);
          var dy = e.clientY - (c.top + c.height / 2);
          var d = Math.hypot(dx, dy) || 1;
          var r = Math.min(c.width * 0.14, 4);
          o.style.transform = "translate(" + (dx / d) * r + "px," + (dy / d) * r + "px)";
        });
      },
      { passive: true },
    );
  }

  /* Todo se sella en su propio elemento, así que arrancar() se puede volver a
     llamar cuantas veces haga falta: engancha lo que llegó nuevo y deja en paz
     lo que ya estaba. Es lo que pide el editor de temas, que recarga secciones
     sueltas cada vez que el cliente mueve un ajuste. */
  function arrancar() {
    revelados();
    document.querySelectorAll("[data-eu-carrusel]").forEach(carrusel);
    document.querySelectorAll("[data-eu-acordeon]").forEach(acordeon);
    megaMenu();
    menuMovil();
    cabecera();
    ojitos();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arrancar);
  else arrancar();

  // El editor de temas recarga secciones sueltas: hay que volver a engancharlas.
  document.addEventListener("shopify:section:load", arrancar);
})();

/* ------------------------------------------------------------------
   EL AVISO DE RECIEN AGREGADO EN EL CAJON DEL CARRITO

   theme.js vuelve a pintar el interior de #CartDrawerMain en cada cambio y no
   dice cual linea acaba de entrar. Asi que la foto del carrito se toma en el
   momento del clic en «agregar»: cuando el cajon se vuelve a pintar, la fila
   que no estaba en esa foto —o que subio de cantidad— es la reciente.

   Tomarla al hacer clic, y no en cada mutacion, evita que el propio repintado
   se adelante y borre la referencia. Abrir el cajon sin agregar nada no marca
   ninguna fila, que es como se comporta el sitio.
   ------------------------------------------------------------------ */
(function () {
  /* theme.js repinta el cajon mas de una vez por alta, asi que la foto no se
     borra al marcar: se mantiene unos segundos y la marca se vuelve a poner en
     cada repintado de esa tanda. Si no, el segundo render se la lleva. */
  var VENTANA = 6000;
  /* Tope absoluto desde el clic. La ventana se re-arma en cada repintado que
     detecta el alta: si el store tarda (una seccion pesada, una conexion
     lenta), el primer repintado puede llegar pasados los 6 s del clic y antes
     la marca se perdia. Con esto la cuenta empieza cuando de verdad se pinta. */
  var TOPE = 20000;
  var foto = null;
  var hasta = 0;
  var tope = 0;
  var pendiente = null;

  function leer() {
    var mapa = {};
    var filas = document.querySelectorAll("#CartDrawerMain .cart-drawer-item");
    for (var i = 0; i < filas.length; i++) {
      var k = filas[i].getAttribute("data-key");
      if (k) mapa[k] = parseInt(filas[i].getAttribute("data-cantidad"), 10) || 0;
    }
    return mapa;
  }

  function marcar() {
    if (!foto) return;
    if (Date.now() > hasta || Date.now() > tope) {
      foto = null;
      return;
    }
    var filas = document.querySelectorAll("#CartDrawerMain .cart-drawer-item");
    var reciente = null;
    for (var i = 0; i < filas.length; i++) {
      var el = filas[i];
      var k = el.getAttribute("data-key");
      var q = parseInt(el.getAttribute("data-cantidad"), 10) || 0;
      if (!k) continue;
      if (!(k in foto) || q > foto[k]) reciente = el;
    }
    if (reciente) {
      reciente.classList.add("eu-reciente");
      hasta = Date.now() + VENTANA;
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest(".product-card-add-btn, .quick-add-trigger, [name='add']")) return;
      foto = leer();
      hasta = Date.now() + VENTANA;
      tope = Date.now() + TOPE;
    },
    true,
  );

  function arrancar() {
    var main = document.getElementById("CartDrawerMain");
    if (!main || !main.parentNode) return;
    var padre = main.parentNode;
    if (padre.dataset.euRecienteObservado) return;
    padre.dataset.euRecienteObservado = "1";
    new MutationObserver(function () {
      if (pendiente) clearTimeout(pendiente);
      pendiente = setTimeout(marcar, 80);
    }).observe(padre, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arrancar);
  else arrancar();
})();

/* ------------------------------------------------------------------
   TECLADO EN EL CAJON DEL CARRITO

   El Escape del tema base solo cierra el menu movil, y al abrir el cajon el
   foco se quedaba en el body: un panel modal sin trampa de foco. Esto lo
   arregla sin tocar theme.js, que es archivo del tema original.

   Al abrirse, el foco entra en el cajon y se recuerda quien lo abrio; el Tab
   da vueltas dentro; Escape lo cierra y devuelve el foco a su sitio.
   ------------------------------------------------------------------ */
(function () {
  var cajon = document.getElementById("CartDrawer");
  if (!cajon) return;
  var abridor = null;

  function enfocables() {
    return [].slice
      .call(cajon.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (e) {
        return e.offsetWidth > 0 || e.offsetHeight > 0;
      });
  }

  function abierto() {
    return cajon.classList.contains("is-open");
  }

  function cerrar() {
    cajon.classList.remove("is-open");
    document.body.style.overflow = "";
    if (abridor && abridor.focus) abridor.focus();
    abridor = null;
  }

  document.addEventListener(
    "click",
    function (e) {
      var t = e.target;
      if (t && t.closest && t.closest(".cart-badge-container, .cart-drawer-trigger, .product-card-add-btn")) {
        abridor = t.closest(".cart-badge-container, .cart-drawer-trigger, .product-card-add-btn");
      }
    },
    true,
  );

  document.addEventListener("keydown", function (e) {
    if (!abierto()) return;
    if (e.key === "Escape") {
      e.preventDefault();
      cerrar();
      return;
    }
    if (e.key !== "Tab") return;
    var lista = enfocables();
    if (!lista.length) return;
    var primero = lista[0];
    var ultimo = lista[lista.length - 1];
    if (e.shiftKey && document.activeElement === primero) {
      e.preventDefault();
      ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault();
      primero.focus();
    } else if (!cajon.contains(document.activeElement)) {
      e.preventDefault();
      primero.focus();
    }
  });

  /* Cuando theme.js le pone is-open, el foco entra al cajon. */
  new MutationObserver(function () {
    if (!abierto()) return;
    setTimeout(function () {
      if (cajon.contains(document.activeElement)) return;
      var lista = enfocables();
      if (lista.length) lista[0].focus();
    }, 320);
  }).observe(cajon, { attributes: true, attributeFilter: ["class"] });
})();

/* ------------------------------------------------------------------
   LOS FILTROS DE LA COLECCION

   El panel es barra lateral desde 1024 px y cajon por debajo; el mismo
   formulario en los dos casos. El desplegable de orden manda solo, y las
   facetas se aplican al cambiar cualquier casilla o al salir de un precio.
   Sin JavaScript quedan los botones «Aplicar» y «Ordenar» del noscript.
   ------------------------------------------------------------------ */
(function () {
  var orden = document.querySelector("[data-eu-orden] select[name='sort_by']");
  if (orden) {
    orden.addEventListener("change", function () {
      orden.form.submit();
    });
  }

  var raiz = document.querySelector("[data-eu-filtros]");
  if (!raiz) return;
  var panel = raiz.querySelector(".eu-filtros-panel");
  var form = raiz.querySelector("[data-eu-filtros-form]");
  var abridor = raiz.querySelector("[data-eu-filtros-abrir]");

  function abrir() {
    raiz.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var primero = panel.querySelector("button, a, input");
    if (primero) primero.focus();
  }

  function cerrar() {
    raiz.classList.remove("is-open");
    document.body.style.overflow = "";
    if (abridor) abridor.focus();
  }

  raiz.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    if (e.target.closest("[data-eu-filtros-abrir]")) return abrir();
    if (e.target.closest("[data-eu-filtros-cerrar]")) return cerrar();
  });

  /* El velo es un ::before de la raiz: un clic fuera del panel lo cierra. */
  raiz.addEventListener("mousedown", function (e) {
    if (!raiz.classList.contains("is-open")) return;
    if (panel.contains(e.target)) return;
    if (e.target.closest("[data-eu-filtros-abrir]")) return;
    cerrar();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && raiz.classList.contains("is-open")) cerrar();
  });

  if (!form) return;

  /* Las facetas se aplican solas; el precio espera a que sueltes el campo. */
  function aplicar() {
    var datos = new FormData(form);
    var partes = [];
    datos.forEach(function (valor, clave) {
      if (String(valor).length) partes.push(encodeURIComponent(clave) + "=" + encodeURIComponent(valor));
    });
    window.location.search = partes.join("&");
  }

  form.addEventListener("change", function (e) {
    if (e.target.type === "number") return;
    aplicar();
  });

  /* El precio se aplica al soltar el campo, pero SOLO si cambio algo. Antes se
     aplicaba siempre: bastaba tabular por «Precio desde» —o entrar y salir sin
     escribir— para que la pagina se recargara sola, y con el teclado no habia
     forma de pasar de largo. Se guarda el valor al entrar y se compara al salir. */
  var precioAlEntrar = "";
  form.addEventListener("focus", function (e) {
    if (e.target.type === "number") precioAlEntrar = e.target.value;
  }, true);
  form.addEventListener("blur", function (e) {
    if (e.target.type !== "number") return;
    if (e.target.value === precioAlEntrar) return;
    aplicar();
  }, true);
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    aplicar();
  });
})();

/* ------------------------------------------------------------------
   LA FICHA DE PRODUCTO

   El formulario funciona sin JavaScript: es un POST a /cart/add. Con JS, el
   selector cambia el precio y la variante del boton, que lleva el gancho AJAX
   del tema base para que el alta abra el cajon en vez de recargar.
   ------------------------------------------------------------------ */
(function () {
  var raiz = document.querySelector("[data-eu-producto]");
  if (!raiz) return;

  /* las miniaturas cambian la foto grande */
  var grande = raiz.querySelector("[data-eu-producto-foto]");
  raiz.addEventListener("click", function (e) {
    var mini = e.target.closest && e.target.closest("[data-eu-producto-mini]");
    if (!mini || !grande) return;
    grande.removeAttribute("srcset");
    grande.src = mini.getAttribute("data-eu-producto-mini");
    var todas = raiz.querySelectorAll("[data-eu-producto-mini]");
    for (var i = 0; i < todas.length; i++) {
      todas[i].classList.toggle("border-verde", todas[i] === mini);
      todas[i].classList.toggle("border-verde/25", todas[i] !== mini);
    }
  });

  /* Las opciones eligen variante: se resuelve contra product.variants. */
  var datos = raiz.querySelector("[data-eu-variantes]");
  var oculto = raiz.querySelector("[data-eu-producto-variante]");
  var boton = raiz.querySelector("[data-eu-producto-form] button[type='submit']");
  var cifra = raiz.querySelector("[data-eu-producto-cifra]");
  if (!datos || !oculto || !boton) return;

  var variantes = [];
  try {
    variantes = JSON.parse(datos.textContent);
  } catch (e) {
    return;
  }

  function elegidas() {
    var out = [];
    var grupos = raiz.querySelectorAll("[data-eu-opcion]");
    for (var i = 0; i < grupos.length; i++) {
      var marcado = grupos[i].querySelector("input[data-eu-valor]:checked");
      out.push(marcado ? marcado.value : null);
    }
    return out;
  }

  function resolver() {
    var v = elegidas();
    for (var i = 0; i < variantes.length; i++) {
      var ok = true;
      for (var j = 0; j < v.length; j++) {
        if (v[j] !== null && variantes[i].options[j] !== v[j]) ok = false;
      }
      if (ok) return variantes[i];
    }
    return null;
  }

  /* Una combinacion que no existe no se puede elegir: se apaga su etiqueta. */
  function repintar() {
    var v = elegidas();
    var grupos = raiz.querySelectorAll("[data-eu-opcion]");
    for (var g = 0; g < grupos.length; g++) {
      var radios = grupos[g].querySelectorAll("input[data-eu-valor]");
      for (var r = 0; r < radios.length; r++) {
        var prueba = v.slice();
        prueba[g] = radios[r].value;
        var existe = false;
        for (var i = 0; i < variantes.length; i++) {
          var ok = true;
          for (var j = 0; j < prueba.length; j++) {
            if (prueba[j] !== null && variantes[i].options[j] !== prueba[j]) ok = false;
          }
          if (ok && variantes[i].available) existe = true;
        }
        radios[r].disabled = !existe;
      }
      var elegido = grupos[g].querySelector("[data-eu-opcion-elegido]");
      var marcado = grupos[g].querySelector("input[data-eu-valor]:checked");
      if (elegido && marcado) elegido.textContent = marcado.value;
    }
  }

  raiz.addEventListener("change", function (e) {
    if (!e.target.matches || !e.target.matches("input[data-eu-valor]")) return;
    var variante = resolver();
    repintar();
    if (!variante) {
      boton.disabled = true;
      return;
    }
    oculto.value = variante.id;
    boton.setAttribute("data-variant-id", variante.id);
    boton.disabled = !variante.available;
    if (cifra) cifra.textContent = String(Math.round(variante.price / 100));
    /* comprar ahora lleva la variante elegida al checkout */
    var directo = raiz.querySelector("[data-eu-comprar-ahora]");
    if (directo) {
      directo.href = directo.href.replace(/id=\d+/, "id=" + variante.id);
      if (variante.available) {
        directo.removeAttribute("aria-disabled");
        directo.removeAttribute("tabindex");
      } else {
        directo.setAttribute("aria-disabled", "true");
        directo.setAttribute("tabindex", "-1");
      }
    }
    /* la barra del movil enseña el mismo precio y se apaga con la misma variante */
    var cifraBarra = raiz.querySelector("[data-eu-barra-cifra]");
    var botonBarra = raiz.querySelector("[data-eu-barra-agregar]");
    if (cifraBarra) cifraBarra.textContent = String(Math.round(variante.price / 100));
    if (botonBarra) botonBarra.disabled = !variante.available;
    var foto = variante.featured_image;
    if (foto && grande) {
      grande.removeAttribute("srcset");
      grande.src = foto.src;
    }
    /* Antes se reenganchaba el boton en cada cambio de variante y el tema base
       sumaba un escuchador mas sin soltar el anterior: al tercer cambio, un
       clic mandaba tres unidades. El escuchador original ya lee
       data-variant-id al hacer clic, que es lo que se acaba de actualizar. */
  });

  repintar();
})();

/* ------------------------------------------------------------------
   LOS RELACIONADOS

   Se piden al motor de recomendaciones de Shopify con section_id, que es como
   lo hacen sus temas: la ficha se pinta sin esperar por esto, y si el motor no
   tiene datos todavia cae solo a la coleccion de la pieza.
   ------------------------------------------------------------------ */
(function () {
  var hueco = document.querySelector("[data-eu-relacionados]");
  if (!hueco) return;
  var url = hueco.getAttribute("data-url");
  if (!url) return;

  fetch(url)
    .then(function (r) {
      return r.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var seccion = doc.querySelector("#relacionados");
      if (!seccion) return;
      /* La sección llega con su hoja de estilos delante; se lleva al head
         una sola vez en vez de clonarla dentro del hueco. */
      doc.querySelectorAll("link[rel=stylesheet]").forEach(function (l) {
        var href = l.getAttribute("href");
        if (href && !document.querySelector('link[href="' + href + '"]')) {
          document.head.appendChild(l.cloneNode(true));
        }
      });
      hueco.appendChild(seccion);
      if (typeof window.initCartAjaxHandlers === "function") window.initCartAjaxHandlers();
      document.dispatchEvent(new CustomEvent("shopify:section:load", { detail: { sectionId: "relacionados" } }));
    })
    .catch(function () {});
})();

/* ------------------------------------------------------------------
   EL CARRITO EN PAGINA

   La pagina /cart es un formulario POST de toda la vida: `updates[]` con la
   cantidad de cada linea. Asi que + y - no piden nada por AJAX, solo tocan el
   campo y envian el formulario; quitar es poner cero. Menos codigo, ningun
   estado que se pueda desincronizar, y funciona igual si el JS no carga —ahi
   queda el boton «Actualizar» del noscript.
   ------------------------------------------------------------------ */
(function () {
  var forma = document.querySelector("form.cart-page-form");
  if (!forma) return;

  function enviar() {
    /* El navegador pide un boton para requestSubmit; sin el, submit() sirve
       igual porque no hay validacion que saltarse. */
    if (forma.requestSubmit) forma.requestSubmit();
    else forma.submit();
  }

  forma.addEventListener("click", function (e) {
    var boton = e.target.closest ? e.target.closest(".qty-plus, .qty-minus, .cart-item-remove-btn") : null;
    if (!boton) return;
    e.preventDefault();

    var linea = boton.closest(".eu-linea-carrito");
    var campo = linea && linea.querySelector(".qty-input");
    if (!campo) return;

    if (boton.classList.contains("cart-item-remove-btn")) campo.value = 0;
    else {
      var n = parseInt(campo.value, 10) || 0;
      campo.value = Math.max(0, boton.classList.contains("qty-plus") ? n + 1 : n - 1);
    }
    boton.setAttribute("aria-busy", "true");
    enviar();
  });

  /* Escribir a mano una cantidad y salir del campo cuenta como cambio. */
  forma.addEventListener("change", function (e) {
    if (e.target.classList && e.target.classList.contains("qty-input")) enviar();
  });
})();

/* ------------------------------------------------------------------
   LA BARRA DE COMPRA DEL MOVIL

   Aparece pegada al pie cuando el boton principal de la ficha ya quedo por
   encima de la pantalla, y se esconde al volver arriba. Se mira en cada
   scroll con un solo frame en vuelo. No es un IntersectionObserver a
   proposito: si el boton salta de debajo a encima de un tiron —un ancla, un
   scroll rapido— no hay cruce que observar y la barra no apareceria.

   Su boton pulsa el de verdad: la mecanica AJAX del tema base es una sola.
   ------------------------------------------------------------------ */
(function () {
  var raiz = document.querySelector("[data-eu-producto]");
  if (!raiz) return;
  var barra = raiz.querySelector("[data-eu-barra]");
  var principal = raiz.querySelector("[data-eu-producto-form] button[type='submit']");
  var agregar = raiz.querySelector("[data-eu-barra-agregar]");
  if (!barra || !principal) return;

  var pedido = 0;
  function mirar() {
    pedido = 0;
    var fuera = principal.getBoundingClientRect().bottom < 0;
    barra.classList.toggle("translate-y-full", !fuera);
    barra.setAttribute("aria-hidden", fuera ? "false" : "true");
    if (agregar) agregar.tabIndex = fuera ? 0 : -1;
  }
  function alScroll() {
    if (!pedido) pedido = window.requestAnimationFrame(mirar);
  }
  mirar();
  window.addEventListener("scroll", alScroll, { passive: true });
  window.addEventListener("resize", alScroll, { passive: true });

  if (agregar) {
    agregar.addEventListener("click", function () {
      if (principal.disabled) return;
      principal.click();
    });
  }
})();


/* ---------------------------------------------------------------------------
   LA GUÍA DE TALLAS
   El enlace vive pegado al selector, que es donde nace la duda, pero la tabla
   está más abajo. Al pulsarlo se abre y se baja hasta ella.
--------------------------------------------------------------------------- */
document.addEventListener("click", function (ev) {
  var boton = ev.target.closest("[data-eu-abre-tallas]");
  if (!boton) return;
  var caja = document.querySelector("[data-eu-tallas]");
  if (!caja) return;
  caja.open = true;
  caja.scrollIntoView({ block: "center", behavior: "smooth" });
});
